import { Children, cloneElement } from "react";
import cn from "classnames";
import s from "./Tabs.module.scss";

const TabContainer = ({ children, active, className }) => {
  const childrens = Children.toArray(children);
  return (
    <div className={cn(s.container, className)}>
      {childrens.map((child, index) =>
        cloneElement(child, {
          active: active == index,
        })
      )}
    </div>
  );
};

export default TabContainer;
